import { jsx as v } from "@emotion/react/jsx-runtime";
import { useReducer as C, useEffect as D, useMemo as m, createContext as f, useContext as h } from "react";
import { countFilters as p } from "./helpers.js";
import { updateFilters as w, reset as y } from "./reducer/dynamicFilters.actions.js";
import { filtersReducer as P, createFreshInitialState as a } from "./reducer/dynamicFilters.reducer.js";
const d = f(void 0), M = () => {
  const t = h(d);
  if (!t)
    throw new Error("useDynamicFiltersContext must be used within a DynamicFiltersProvider");
  return t;
}, S = ({
  filters: t,
  onApply: r,
  children: x,
  schema: o,
  isFilterOpen: n,
  setIsFilterOpen: c
}) => {
  const [i, e] = C(P, t || a(o)), s = () => {
    r(a(o)), e(y(o));
  };
  D(() => {
    e(w(t));
  }, [t, e]);
  const u = m(() => p(t), [t]), F = m(() => ({
    filters: t,
    preFilters: i,
    count: u,
    handleReset: s,
    onApply: r,
    dispatch: e,
    isFilterOpen: n,
    setIsFilterOpen: c
  }), [t, u, s, i, r, e, n, c]);
  return /* @__PURE__ */ v(d.Provider, { value: F, children: x });
};
export {
  S as DynamicFiltersProvider,
  M as useDynamicFiltersContext
};
